import { render, staticRenderFns } from "./Coalition.vue?vue&type=template&id=bd8ca258&"
import script from "./Coalition.vue?vue&type=script&lang=js&"
export * from "./Coalition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports